import { style } from '@angular/animations';
import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'split-tooltip-info',
  templateUrl: './split-tooltip-info.component.html',
  styleUrls: ['./split-tooltip-info.component.scss'],
  host: {
    class: 'flex gap-1 justify-content-center align-items-center'
  }
})
export class SplitTooltipInfoComponent {
  @Input({required: true}) tooltipText: string = '';
}
